import { GlobalSearch } from '@features/GlobalSearch'
import { useLastSeen } from '@state/lastSeen'
import { useSessionRealtime } from '@state/useSessionRealtime'
import { type ParentComponent, onMount } from 'solid-js'
import { Box, Grid } from 'styled-system/jsx'
import OnboardingRedirect from '../guards/OnboardingRedirect'
import { RouteGuard } from '../guards/RouteGuard'
import { usePushEvents } from '../startup/usePushEvents'
import Header from './Header'
import Toast from './Toast'

export const Container: ParentComponent = (props) => {
  onMount(() => {
    usePushEvents()
    useSessionRealtime()
    useLastSeen()
  })

  return (
    <Box pt='var(--safe-area-inset-top)' pb='var(--safe-area-inset-bottom)'>
      <RouteGuard>
        <OnboardingRedirect>
          <Grid
            gap={0}
            gridTemplateColumns={{ base: 'auto', md: 'auto 1fr' }}
            gridTemplateRows={{ base: 'auto 1fr', md: '1fr' }}
            alignContent='stretch'
            height='calc(var(--vh) * 100)'
          >
            <Header />
            {props.children}
          </Grid>
          <GlobalSearch />
          <Toast />
        </OnboardingRedirect>
      </RouteGuard>
    </Box>
  )
}

export default Container
